export default __webpack_public_path__ + "static/media/pdd.d2c02858.png";